import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommercialGapProviderByNetworkIdStorage {

  private storageKey = 'commercial-gap-provider';

  public get(networkId: string): boolean | undefined {
    const stringifiedMap = sessionStorage.getItem(this.storageKey);
    if (!stringifiedMap) { return undefined; }

    const map: Map<string, boolean> = JSON.parse(stringifiedMap);
    const isCommercialGapProvider = map[networkId];

    return typeof isCommercialGapProvider === 'boolean' ? isCommercialGapProvider : undefined;
  }

  public set(networkId: string, isCommercialGapProvider: boolean): void {
    const stringifiedMap = sessionStorage.getItem(this.storageKey);
    const map = stringifiedMap ? JSON.parse(stringifiedMap) : {};

    map[networkId] = isCommercialGapProvider;
    sessionStorage.setItem(this.storageKey, JSON.stringify(map));
  }
}
